"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleBinaryCondition = void 0;
const market_rule_condition_1 = require("./market-rule-condition");
class MarketRuleBinaryCondition extends market_rule_condition_1.MarketRuleCondition {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.conditionOperator = obj.conditionOperator;
            this.leftOperand = obj.leftOperand;
            this.rightOperand = obj.rightOperand;
        }
    }
}
exports.MarketRuleBinaryCondition = MarketRuleBinaryCondition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtYmluYXJ5LWNvbmRpdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2hpc3RvcmljYWwtcHJpY2luZy90aW1lLXNlcmllcy9zZXJ2aWNlcy9ydWxlLWVuZ2luZS1zZXJ2aWNlL2NsYXNzZXMvbWFya2V0LXJ1bGUtYmluYXJ5LWNvbmRpdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSxtRUFBOEQ7QUFHOUQsTUFBYSx5QkFBMEIsU0FBUSwyQ0FBbUI7SUFLOUQ7OztPQUdHO0lBQ0gsWUFBbUIsR0FBd0M7UUFDdkQsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBRVgsSUFBSSxHQUFHLEVBQUUsQ0FBQztZQUNOLElBQUksQ0FBQyxpQkFBaUIsR0FBRyxHQUFHLENBQUMsaUJBQWtCLENBQUM7WUFDaEQsSUFBSSxDQUFDLFdBQVcsR0FBRyxHQUFHLENBQUMsV0FBWSxDQUFDO1lBQ3BDLElBQUksQ0FBQyxZQUFZLEdBQUcsR0FBRyxDQUFDLFlBQWEsQ0FBQztRQUMxQyxDQUFDO0lBQ0wsQ0FBQztDQUNKO0FBbEJELDhEQWtCQyJ9